module.exports = __webpack_public_path__ + "static/media/3.47e28840.jpg";